<div class="login-container">
  <div class="content-login">
    <div
      class="w-100 h-100 gap-3 d-flex align-items-center justify-content-center"
    >
      <div class="d-flex flex-column gap-3">
        <div class="logo-login d-flex justify-content-center">
          <img
            style="max-height: 50px"
            src="https://storage.googleapis.com/komerce/core/RO%20by%20Komerce.svg"
          />
        </div>
        <div>
          <form [formGroup]="formGroup" *ngIf="!success">
            <div
              class="px-md-5 px-3 py-3 m-3 card shadow d-flex flex-column gap-3"
            >
              <div class="text-center desc">
                <div class="title mt-3 mb-1">
                  <strong style="font-weight: 600">Forgot Password</strong>
                </div>
                <div>
                  Enter your email, link to reset password
                  <br />
                  will be sent via email
                </div>
              </div>
              <div class="form-group mt-1">
                <label for="username">Email</label>
                <input
                  nz-input
                  nzSize="large"
                  type="email"
                  (keypress)="setRegex($event)"
                  formControlName="email"
                  class="form-control"
                  id="username"
                  aria-describedby="username"
                  placeholder="username@domain.com"
                  (keydown.enter)="$event.preventDefault()"
                  (input)="validateEmail()"
                  [nzStatus]="validEmail ? '' : 'error'"
                />
                <div class="d-flex align-items-center justify-content-between">
                  <span class="text-danger">
                    <img
                      *ngIf="errorUser !== ''"
                      src="https://storage.googleapis.com/komerce/assets/icons/danger-red.svg"
                      alt="warning"
                      style="max-width: 10px; max-height: 10px"
                    />
                    {{ errorUser }}</span
                  >
                  <span
                    *ngIf="errorUser === 'Your email has not been verified'"
                    class="d-flex justify-content-end align-items-end text-blue"
                    style="cursor: pointer"
                    (click)="resendVerif($event)"
                    >Resend</span
                  >
                </div>
                <div class="mb-2 mt-3">
                  <button
                    [disabled]="formGroup.invalid"
                    (click)="getCaptchaToken($event)"
                    class="btn w-100"
                    [ngClass]="
                      formGroup.invalid ? 'btn-secondary' : 'btn-roprimary'
                    "
                  >
                    <div
                      class="d-flex flex-row gap-2 align-items-center justify-content-center"
                    >
                      <div style="color: white">Send</div>
                      <div
                        *ngIf="isLoading"
                        class="spinner-border spinner text-light"
                        role="status"
                      >
                        <span class="sr-only"></span>
                      </div>
                    </div>
                  </button>
                </div>
                <div class="text-center mb-2">
                  Have you remembered your password?
                  <a class="text-yellow" href="/login">Login</a>
                </div>
              </div>
            </div>
          </form>
          <div
            *ngIf="success"
            class="card shadow p-5 d-flex align-items-center justify-content-center gap-3"
          >
            <img
              src="https://storage.googleapis.com/komerce/assets/icons/sms-success.svg"
              alt="succes"
              style="max-width: 50px"
            />
            <h5><strong>Email Sent Successfully</strong></h5>
            <span>Please check your email to reset your password.</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
